'use client';

import { CheckCircle, CircleNotch, Info, Warning, WarningCircle } from '@phosphor-icons/react';
import { useTheme } from 'next-themes';
import * as React from 'react';
import { Toaster as SonnerToaster, toast, type ToasterProps } from 'sonner';

type Theme = 'light' | 'dark' | 'system';

export function Toaster(props: ToasterProps): React.ReactElement {
  const { resolvedTheme } = useTheme();
  const theme: Theme = resolvedTheme === 'dark' ? 'dark' : 'light';

  return (
    <SonnerToaster
      theme={theme}
      className="toaster group"
      gap={10}
      icons={{
        success: <CheckCircle className="text-success size-4.5" weight="fill" />,
        error: <WarningCircle className="text-destructive size-4.5" weight="fill" />,
        warning: <Warning className="text-warning-strong size-4.5" weight="fill" />,
        info: <Info className="text-info size-4.5" weight="fill" />,
        loading: (
          <CircleNotch className="text-muted-foreground size-4.5 animate-spin" weight="bold" />
        ),
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-popover/85 group-[.toaster]:text-foreground group-[.toaster]:border-border/70 group-[.toaster]:rounded-2xl group-[.toaster]:backdrop-blur-xl group-[.toaster]:gap-2.5 group-[.toaster]:px-4 group-[.toaster]:py-3.5 group-[.toaster]:shadow-[inset_0_1px_0_hsl(0_0%_100%/0.5),0_12px_32px_-12px_hsl(var(--foreground)/0.28),0_2px_8px_-4px_hsl(var(--foreground)/0.12)] dark:group-[.toaster]:shadow-[inset_0_1px_0_hsl(0_0%_100%/0.06),0_12px_32px_-12px_hsl(0_0%_0%/0.6)]',
          title:
            'group-[.toast]:text-[13px] group-[.toast]:font-semibold group-[.toast]:leading-snug',
          description:
            'group-[.toast]:text-muted-foreground group-[.toast]:text-xs group-[.toast]:leading-relaxed',
          icon: 'group-[.toast]:mt-0.5 group-[.toast]:self-start',
          actionButton:
            'group-[.toast]:bg-cta group-[.toast]:text-cta-foreground group-[.toast]:rounded-lg group-[.toast]:text-xs group-[.toast]:font-medium',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-lg group-[.toast]:text-xs',
          closeButton:
            'group-[.toast]:bg-background group-[.toast]:border-border group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}

export { toast };
